<fa-icon [icon]="icon" [pTooltip]="'product-bundle.tooltip' | translate" tooltipPosition="top"></fa-icon>
<span>{{ productList }}</span>
